import { useNavigate } from 'react-router';
import { getLang, handlePaymentScreenAction } from '../../../Helpers/functions';
import style from '../PaymentStatusScreen.module.css';

interface WidgetProps {
    widget : any
    paymentSecret : string
    cartId : string
    modelId : string
    referrerUrl : string
}

const GetStarted = ({widget,paymentSecret,cartId,modelId,referrerUrl} : WidgetProps) => {
    const gradient = getLang() == "ar" ? "linear-gradient(to right, #2B3757, #060223)" : "linear-gradient(to left, #2B3757, #060223)";
    const navigate = useNavigate();

    const handleNextAction = () => {
        handlePaymentScreenAction({paymentSecret,cartId,modelId,widget,navigate,referrerUrl})
    }

    return <div className="card border-0 shadow-sm mt-3 ">
        <div className="card-body payment_success_card_radius" style={{background: gradient}}>
            <div style={{fontSize : "16px"}} className='text-white d-flex justify-content-between'>
                <div>
                    <strong className='fw-bolder' style={{fontSize : "17px"}}>
                        {widget.header}
                    </strong>
                    <p style={{fontSize : "14px", maxWidth : "300px"}} className='mt-1'> 
                        {widget.description}
                    </p>
                </div>
                
                <img className={` bottom-0 ${getLang() == 'ar' ? 'start-0' : 'end-0'}`} height="87" src={widget.image.replace("{platform}","android").replace("{size}","h")}/>
            </div>
            <button onClick={handleNextAction} className='btn fw-bold w-100 mt-2' style={{backgroundColor : widget.button.background, color : widget.button.textColor, fontSize :"17px"}}>
                {widget.button.text}
            </button>
        </div>
    </div>
}

export default GetStarted;